import { render, staticRenderFns } from "./InstitutionsBar.vue?vue&type=template&id=f83aad36&"
import script from "./InstitutionsBar.vue?vue&type=script&lang=js&"
export * from "./InstitutionsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports